<template>
  <p>{{ $t('message.language') }}</p>
  <LocaleSwitcher />
</template>

<script>
import { defineComponent } from 'vue'
import LocaleSwitcher from "./LocaleSwitcher.vue";

export default {
  name: 'HelloI18n',
  components: { LocaleSwitcher }
}
</script>

